import { useMemo } from 'react';
import { getProperty } from '../../../fsConfig';
import { SUPER_ADMIN_ACCOUNT_ID } from '../../../constants';

interface NavigationPermissions {
    canIssueReports: boolean;
    canManageIssues: boolean;
    canAccessTravelerMap: boolean;
    canViewWaivers: boolean;
    isAccountAdmin: boolean;
    isWaiverAdmin: boolean;
    canUseWaiverReports: boolean;
    multiTabView: boolean;
    showAdmin: boolean;
    isSuperAdminInSudo: boolean;
    isSuperAdmin: boolean;
}

export const useNavigationPermissions = (): NavigationPermissions => {
    const user = getProperty('session', {});

    return useMemo(() => {
        const {
            canIssueReports,
            canManageIssues,
            canViewTravelerMap,
            canViewWaivers,
            canUseWaiverReports,
            isAccountAdmin,
            isWaiverAdmin,
            multiTabView,
            showAdmin,
            accountId,
            suUid,
            suUsername,
        } = user;

        const isSuperAdminInSudo = Boolean(suUid && suUsername);
        const isSuperAdmin = accountId === SUPER_ADMIN_ACCOUNT_ID && showAdmin?.();

        return {
            canIssueReports: canIssueReports?.() || false,
            canManageIssues: canManageIssues?.() || false,
            canAccessTravelerMap: canViewTravelerMap?.() || isSuperAdminInSudo,
            canViewWaivers: canViewWaivers?.() || false,
            isAccountAdmin: isAccountAdmin?.() || false,
            isWaiverAdmin: isWaiverAdmin?.() || false,
            canUseWaiverReports: canUseWaiverReports?.() || false,
            multiTabView: multiTabView?.() || false,
            showAdmin: showAdmin?.() || false,
            isSuperAdminInSudo,
            isSuperAdmin,
        };
    }, [user]);
};